import { RowSizes } from "~/components/DataGrid";
import { cn } from "~/lib/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBolt } from "@fortawesome/pro-solid-svg-icons";

// // // //

export function AdditionalNetworksRow(props: { size: RowSizes }) {
    const { size } = props;
    return (
        <tr className="flex flex-row">
            <td scope="col" className="flex grow whitespace-nowrap bg-inherit">
                <div
                    className={cn(
                        "px-4 font-normal text-foreground w-full h-full flex items-center",
                        {
                            "py-0": size === RowSizes.extraSmall,
                            "py-1.5": size === RowSizes.small,
                            "py-3": size === RowSizes.medium,
                            "py-6": size === RowSizes.large,
                            "py-8": size === RowSizes.extraLarge,
                        },
                        {
                            "text-xs": size === RowSizes.extraSmall,
                            "text-sm": size === RowSizes.small,
                            "text-base": size === RowSizes.medium,
                            "text-xl": size === RowSizes.large,
                            "text-2xl": size === RowSizes.extraLarge,
                        },
                    )}
                >
                    <div className="text-slate-600 flex">
                        <div className="text-slate-600 invisible hidden lg:block">
                            Additional network integrations coming soon!
                        </div>

                        <div className="text-slate-600 flex items-center gap-1.5 lg:absolute lg:left-12">
                            <FontAwesomeIcon
                                icon={faBolt}
                                className="h-4 text-yellow-400"
                            />
                            Additional network integrations coming soon!
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    );
}
